import React from "react";
import { Link } from "react-router-dom";
import AuthShell from "./AuthShell";

const EmailError = () => {
  return (
    <AuthShell
      title="Email Verified"
      heading="Your email has already been verified."
      subheading="Please return to the login page to access the ProcureX platform. If you need assistance, don't hesitate to contact our support team."
      size="wide"
      brandHeadline="Back to work in a couple of minutes."
      brandSubcopy="Your projects, schedules and daily progress are exactly where you left them."
    >
      <Link className="pxauth-btn" to={`/`}>
        Back to login
      </Link>
    </AuthShell>
  );
};
export default EmailError;
